import { CustomEventWithDetail, CustomEventWithoutDetail, html, on, View } from 'rune-ts';
import klass from './Input.module.scss';
import { cx, cxIf } from '../util';

export interface InputData {
  id: string;
  name: string;
  type?: string;
  placeholder?: string;
  value?: string;
  klass?: string;
  disabled?: boolean;
  warning?: boolean;
  readonly?: boolean;
}

export class HandleInputEvent extends CustomEventWithDetail<{ value: string }> {}
export class EnterEvent extends CustomEventWithoutDetail {}
export class BlurEvent extends CustomEventWithDetail<{ value: string }> {}

export class Input extends View<InputData> {
  override template() {
    const { id, name, type, warning, placeholder, klass: customKlass, value, disabled } = this.data;

    return html` <div class="${cx(klass.inputcontainer, cxIf(warning, klass.warning), customKlass)}">
      <input
        id="${id}"
        name="${name}"
        type="${type}"
        placeholder="${placeholder}"
        class="${klass.input}"
        value="${value ?? ''}"
        ${disabled ? 'disabled' : ''}
      />
    </div>`;
  }

  setDisabled(disabled: boolean) {
    this.data.disabled = disabled;
  }

  setWarning(warning: boolean) {
    this.data.warning = warning;
  }

  @on('input', `.${klass.input}`)
  _handleInput(e: Event) {
    const target = e.target as HTMLInputElement;
    this.data.value = target.value;

    this.dispatchEvent(HandleInputEvent, {
      bubbles: true,
      detail: { value: this.data.value },
    });
  }

  @on('keydown', `.${klass.input}`)
  _handleKeyDown(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      this.dispatchEvent(EnterEvent, {
        bubbles: true,
      });
    }
  }

  @on('focusout', `.${klass.input}`)
  _handleBlur() {
    const value = this.data.value;
    if (!value) return;

    this.dispatchEvent(BlurEvent, {
      bubbles: true,
      detail: { value },
    });
  }
}
